import React from 'react';
import styled from 'styled-components';
import Icon from '@ey/canvascoreservices/Icon';
import OutputText from '@ey/canvascoreservices/OutputText';
import { IconoirInfoCircle } from '@ey-xd/motif-icon';
import Button from '../../../../CoreWrappers/Button';
const prop = 'notApplicable';

export const config = (labels, action) => ({
    id: `${prop}Column`,
    customHeaderCell: () => <StyledNotApplicableActionHeader body2>{labels.actionColumnName}<Icon src={IconoirInfoCircle} title={labels.titleTip}/></StyledNotApplicableActionHeader>,
    propName: 'notApplicable',
    width: 'var(--px-175)',
    align: 'left',
    customCell: (item) => {
        const props = {
            size: 'small',
            variant: 'text-alt',
            label: labels.actionLabel,
            onClick: () => action(item.accountId)
        };

        return <Button {...props} />;
    }
});

const StyledNotApplicableActionHeader = styled(OutputText)`
    display: flex;
    align-items: center;
    gap: var(--spacing-medium);

    .motif-icon {
        --size: var(--px-16);
    }
`
